module.exports = __webpack_public_path__ + "static/media/img-steem-apps@2x.ec53e83c.png";